module.exports = [
	{
		"title": "base64",
		"path": "/zh-CN/tools/base64.html"
	},
	{
		"title": "cookie",
		"path": "/zh-CN/tools/cookie.html"
	},
	{
		"title": "date format",
		"path": "/zh-CN/tools/date.html"
	},
	{
		"title": "debounce",
		"path": "/zh-CN/tools/debounce-throttle.html"
	},
	{
		"title": "md5",
		"path": "/zh-CN/tools/md5.html"
	},
	{
		"title": "number 格式化工具",
		"path": "/zh-CN/tools/number.html"
	},
	{
		"title": "url 参数解析",
		"path": "/zh-CN/tools/querystring.html"
	},
	{
		"title": "string 处理工具",
		"path": "/zh-CN/tools/string.html"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/tool-routes-zh-CN.json
// module id = 302
// module chunks = 483